<template>
  <client-only>
    <WDesktop v-if="$vuetify.breakpoint.smAndUp" />
    <WMobile v-else />
  </client-only>
</template>

<script>
import WMobile from './WMobile'
import WDesktop from './WDesktop'

export default {
  components: {
    WDesktop,
    WMobile,
  },
}
</script>
